import React from "react";
import { Box, Card, CardContent, Typography } from "@mui/material";
import { Link as RouterLink, useParams } from "react-router-dom";

const Medications = () => {
  const { id } = useParams();

  return (
    <Box sx={{ py: 0.5 }}>
      <Card>
        {/* Header */}
        <Box
          sx={{
            backgroundColor: "#f8f9fa", // replace with your theme's header color
            px: 2,
            py: 1.5,
            borderBottom: "1px solid",
            borderColor: "divider",
          }}
        >
          <Typography
            component={RouterLink}
            to={`/medication/${id}/`}
            variant="h6"
            sx={{
              textDecoration: "none",
              color: "primary.main",
              fontWeight: 800, // fw-bolder equivalent
              display: "inline-block",
              "&:hover": {
                textDecoration: "underline",
              },
            }}
          >
            Medications
          </Typography>
        </Box>

        {/* Body */}
        <CardContent sx={{ backgroundColor: "#ffffff" /* card-body-color */ }}>
          <Typography>No Medications Found</Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default Medications;